import React from 'react';
import styled from 'styled-components';
import TableView from '../../Reusable/TableView';

const ScrollWrapper = styled.div`
    height: 275px;
    position: relative;
    overflow: hidden;
`;

const ScrollContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
`;

const StyledTableView = styled(TableView)`
    // Hide the first row if it's empty
    .ant-table-tbody > tr:first-child:not([data-row-key]) {
        display: none;
    }

    // Ensure consistent styling for data rows
    .ant-table-tbody > tr {
        height: 55px; // Adjust based on your design
    }

    // Remove bottom border from last row
    .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }
`;

// export const ScrollableTableView = (props) => (
//     <ScrollWrapper>
//         <ScrollContent>
//             <StyledTableView {...props} />
//         </ScrollContent>
//     </ScrollWrapper>
// );

export const ScrollableTableView = styled(TableView)`
    .ant-table-container {
        max-height: ${props => props.maxHeight || '275px'};
        overflow-y: auto; // Force scrollbar to always be present
    }

    .ant-table-body {
        max-height: 100% !important;
        overflow-y: auto !important; // Ensure scrollbar is visible on the table body
    }

    // Hide the first row if it's empty
    .ant-table-tbody > tr:first-child:not([data-row-key]) {
        display: none;
    }

    // Ensure consistent styling for data rows
    .ant-table-tbody > tr {
        height: 55px; // Adjust based on your design
    }

    // Remove bottom border from last row
    .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }
`;